
import Services from './base-services'

const service = new Services('products')

export default {
  listActive: () => {
    return service.suiteOperation(() => service.get('list-active?ext=1'))
  },
  listByCustomer: () => {
    return service.suiteOperation(() => service.get('list-by-customer?ext=1'))
  },
  getOneById: (id: number) => {
    return service.suiteOperation(() => service.get(`get-one-by-id?id=${id}`))
  }
}
